import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { AzureSearchDataset } from 'app/model/dataset/azure-search.dataset';

import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { UpdateMethod, UpdateMethodType } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.azureSearch.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(AzureSearchDataset) }
})
export class AzureSearchSink extends CopySink {
    public static readonly MODEL: IModel;
    public static readonly WRITE_BEHAVIOR: IAttribute;
    public static readonly WRITE_BATCH_SIZE: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: __IS_FABRIC_DPE__ ? stringResources.ModelName_IndexAction : stringResources.ModelName_WriteBehavior
    })
    public writeBehavior?: string = writeBehaviorOptionValues.merge;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_SIZE',
        display: stringResources.ModelName_WriteBatchSize,
        constraint: {
            minimum: 1,
            maximum: 1000
        }
    })
    public writeBatchSize?: number = 1000;

    public get updateMethod(): UpdateMethodType {
        switch (this.writeBehavior) {
            case writeBehaviorOptionValues.merge:
                return UpdateMethod.Merge;
            case writeBehaviorOptionValues.upload:
                return UpdateMethod.Replace;
            default:
                return undefined;
        }
    }

    public set updateMethod(value: UpdateMethodType) {
        switch (value) {
            case UpdateMethod.Merge:
                this.writeBehavior = writeBehaviorOptionValues.merge;
                break;
            case UpdateMethod.Replace:
                this.writeBehavior = writeBehaviorOptionValues.upload;
                break;
            default:
        }
    }
}
